import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import LocationSelect from '../../../common/forms/select/LocationSelect';
import UserSelect from '../../../common/forms/select/UserSelect';
import DynamicForm from '../../../common/forms/DynamicForm';
import { SUPPLIER_FOOD_TYPE_COLUMNS } from '../../../../config/dynamicFormFields';
import BusinessInputGroup from '../../../common/forms/BusinessInputGroup';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import {
  BILLING_TYPE,
  CREDIT_TIME,
  SUPPLIER_TYPE,
} from '../../../../config/constants';
import TextInput from '../../../common/forms/input/TextInput';

export const SupplierForm = ({ handleSubmit, loading, edit }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <BusinessInputGroup
        label="Empresa"
        labelRequired
        name="businessId"
        form="SupplierForm"
        validate={[isRequired]}
        showDetails
      />
      <FormGroup row>
        <FormItem label="Tipo de Facturacion" required>
          <Field
            name="billingType"
            component={Select}
            options={enumToSelectOptions(BILLING_TYPE)}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tipo" required>
          <Field
            name="type"
            component={Select}
            options={enumToSelectOptions(SUPPLIER_TYPE)}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Tiempo de Credito" required>
          <Field
            name="creditTime"
            component={Select}
            options={enumToSelectOptions(CREDIT_TIME)}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Ubicación" required>
          <Field
            name="locationId"
            component={LocationSelect}
            placeholder="Ubicación"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Cuenta Bancaria">
          <Field
            name="bankAccountNumber"
            component={TextInput}
            type="text"
            placeholder="Cuenta Bancaria"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Telefono de Contacto">
          <Field
            name="phoneNumber"
            component={TextInput}
            type="text"
            placeholder="Telefono de Contacto"
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Usuario Asociado" required>
          <Field
            name="userId"
            component={UserSelect}
            placeholder="Usuario Asociado"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      {edit && (
        <FormGroup row>
          <FormItem label="Estado">
            <Label>
              <Field name="active" component="input" type="checkbox" /> Activo
            </Label>
          </FormItem>
        </FormGroup>
      )}
      <h3>Tipo de Alimentacion</h3>
      <DynamicForm
        name="supplierFoodTypeList"
        columns={SUPPLIER_FOOD_TYPE_COLUMNS}
      />
      <FormFooter />
    </Form>
  );
};

SupplierForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  edit: PropTypes.bool,
};

SupplierForm.defaultProps = {
  loading: false,
  edit: false,
};

const mapStateToProps = ({ FoodUnit }) => ({
  loading: !FoodUnit.Supplier.getIn(['current', 'activity']).isEmpty(),
});

const formComponent = reduxForm({
  form: 'SupplierForm',
})(SupplierForm);

export default connect(mapStateToProps)(formComponent);
